import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const ProtectedRoute = ({ admin, cosmacia, kpkb, expense }) => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) return null;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const access = user?.dashboardAccess || {};

  // ADMIN routes
  if (admin && !access.dashboard_admin) {
    return <Navigate to="/dashboard" replace />;
  }

  // COSMACIA routes
  if (
    cosmacia &&
    !(
      access.dashboard_admin ||
      (access.dashboard_coordinator && access.dashboard_cosmesia)
    )
  ) {
    return <Navigate to="/dashboard" replace />;
  }

  // KPKB routes
  if (
    kpkb &&
    !(
      access.dashboard_admin ||
      (access.dashboard_coordinator && access.dashboard_kpkb)
    )
  ) {
    return <Navigate to="/dashboard" replace />;
  }

  // EXPENSE routes
  if (expense && !(access.dashboard_admin || access.dashboard_expense)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
